// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"82dedc50","842":"31f45782","847":"a5a92e6a","979":"227c954b"}[chunkId] + ".chunk.js";
};